export default {
  newWindow: 'Si apre in una nuova finestra',
}
